export const numBars =
    [{value: 8, label: 8}, {value: 16, label: 16}, {value: 32, label: 32}]

export const chordDiversity =
    [{value: "Low", label: "Low"}, {value: "Medium", label: "Medium"}, {value: "High", label: "High"}]

export const chordValues = [{value: 'None', label: 'None'}, {value: 'Cmaj7', label: 'Cmaj7'},
  {value: 'C-7', label: 'Cm7'}, {value: 'C7', label: 'C7'}, {value: 'C-7b5', label: 'Cm7b5'},
  {value: 'Dbmaj7', label: 'Dbmaj7'}, {value: 'Db-7', label: 'Dbm7'}, {value: 'Db7', label: 'Db7'},
  {value: 'Db-7b5', label: 'Dbm7b5'}, {value: 'Dmaj7', label: 'Dmaj7'}, {value: 'D-7', label: 'Dm7'},
  {value: 'D7', label: 'D7'}, {value: 'D-7b5', label: 'Dm7b5'}, {value: 'Ebmaj7', label: 'Ebmaj7'},
  {value: 'Eb-7', label: 'Ebm7'}, {value: 'Eb7', label: 'Eb7'}, {value: 'Eb-7b5', label: 'Ebm7b5'},
  {value: 'Emaj7', label: 'Emaj7'}, {value: 'E-7', label: 'Em7'}, {value: 'E7', label: 'E7'},
  {value: 'E-7b5', label: 'Em7b5'}, {value: 'Fmaj7', label: 'Fmaj7'}, {value: 'F-7', label: 'Fm7'},
  {value: 'F7', label: 'F7'}, {value: 'F-7b5', label: 'Fm7b5'}, {value: 'Gbmaj7', label: 'Gbmaj7'},
  {value: 'Gb-7', label: 'Gbm7'}, {value: 'Gb7', label: 'Gb7'}, {value: 'Gb-7b5', label: 'Gbm7b5'},
  {value: 'Gmaj7', label: 'Gmaj7'}, {value: 'G-7', label: 'Gm7'}, {value: 'G7', label: 'G7'},
  {value: 'G-7b5', label: 'Gm7b5'}, {value: 'Abmaj7', label: 'Abmaj7'}, {value: 'Ab-7', label: 'Abm7'},
  {value: 'Ab7', label: 'Ab7'}, {value: 'Ab-7b5', label: 'Abm7b5'}, {value: 'Amaj7', label: 'Amaj7'},
  {value: 'A-7', label: 'Am7'}, {value: 'A7', label: 'A7'}, {value: 'A-7b5', label: 'Am7b5'},
  {value: 'Bbmaj7', label: 'Bbmaj7'}, {value: 'Bb-7', label: 'Bbm7'}, {value: 'Bb7', label: 'Bb7'},
  {value: 'Bb-7b5', label: 'Bbm7b5'}, {value: 'Bmaj7', label: 'Bmaj7'}, {value: 'B-7', label: 'Bm7'},
  {value: 'B7', label: 'B7'}, {value: 'B-7b5', label: 'Bm7b5'}]

export const brightness = [{value: "Light", label: "Light"}, {value: "Regular", label: "Regular"}, {value: "Dark", label: "Dark"}]